export default "__VITE_PUBLIC_ASSET__3372e9d8__"